/**
 * Created by henriquemasca on 12/2/19.
 */

import React, { Component } from "react";
//import { Link } from "react-router-dom";
import { withTranslation } from 'react-i18next';

import AuthService from "../../utils/auth.service";
//import ShowValue from "../../components/ShowValue";
import MessageModal from "../../components/Message";
import Loading from "../../components/Loading";

class ProfileAgentPage extends Component {
	
  constructor(props) {
    super(props);

    let company_code = localStorage.getItem('company_code');
    
    this.state = {
      st_company_code: company_code,
      
      profile: AuthService.profileUser,
      
      modal: {
        isOpen: false,
        title: "",
        message: ""
      },
      loading: false,
      assetMessage: ""
    };

    document.addEventListener("profileLoaded", data => {
      
      if (data.detail && data.detail.profile) {
        const profile = data.detail.profile;
        this.setState(...this.state, { profile: profile })
      }
    });

    this.toggleAlert = this.toggleAlert.bind(this);
    this.handleBack = this.handleBack.bind(this);
    this.goToHome = this.goToHome.bind(this);
  }

  componentDidMount() {
    AuthService.refresh();
    
    //let navigateState = this.props.location.state;
    //if (navigateState && navigateState.showDepositSuccess) {
    //	this.setState({
		 //   modal: {
	    //    title: "Transaction status",
			 //   message: "Aguardando confirmação...",
			 //   isOpen: true
		    //}
    	//});
	    //this.state.modal.title = ;
	    //this.state.modal.message = ;
	    //this.state.modal.isOpen = true;
      //navigateState.showDepositSuccess = false;
      //setTimeout(() => {
      //  AuthService.refresh();
      //}, 5000)
    //}
  }

  handleBack() {
    this.props.history.goBack();
  }

  goToHome() {
    this.props.history.push({
      pathname: '/',
    });
  }

  toggleAlert() {
    this.setState(...this.state, {
      modal: { isOpen: !this.state.modal.isOpen }
    });
  }

  render() {
  	
  	const { t } = this.props;
  	
    return (
      <section className="profile-page">
        <div className="container">

          <h4 className="pt-4">Agent Page</h4>
          {/* Balances header */}
          <div className="row justify-content-center">
            <div className="col-md-8">
              <div className="text-center">
                <h4>My Influencers:</h4>
                <br />
                
	              <h4>You manage no influencers, yet...</h4>
	              
	              <br/>
                
              </div>
            </div>{" "}
          </div>
	        

          <div className="row justify-content-center">
            <div className="col-md-8">
              <button onClick={this.handleBack}
                className="btn btn-outline-secondary float-left">
	              {t('common.back')}
              </button>{" "}
	            
              
              {/*<Link className="btn btn-outline-success float-right"*/}
                    {/*to="/profile/creditcards">*/}
	              {/*{t('wallet.deposit')}*/}
              {/*</Link>*/}
	            
	            <button
		            hidden={!this.state.profile.agent}
                className="btn btn-outline-success float-right">
                Add Influencer
              </button>
	            
	            <a hidden={this.state.profile.agent} className="btn btn-outline-danger float-right"
	               href={`mailto:rc@winvite.io?subject=Olá Meu nome é: ${this.state.profile.name},
	                       &body=Time da Winvite.io,
	                        Gostaria de me tornar um agente ...
	                        Obrigado.
	                        %0D`}>
		            I want to be an agent...
	            </a>
             
            </div>
          </div>
          
          <div className="row justify-content-md-start">
	          <div className="col-md-8">
		          
		          <hr /><hr />
		          
		          {/*{t('wallet.tobuy')} <hr />*/}
		          {/**/}
		          {/*{t('wallet.tip1')}<hr />*/}
		          {/**/}
		          {/*{t('wallet.tip2')} <hr />*/}
		          {/**/}
		          {/*{t('wallet.tip3')} <hr />*/}
		          {/**/}
		          {/*{t('wallet.tip4')}*/}
		          
	          </div>
          </div>
          

          <Loading active={this.state.loading} />
          <MessageModal
            isOpen={this.state.modal.isOpen}
            toggle={this.toggleAlert}
            title={this.state.modal.title}
            message={this.state.modal.message}
          />
        </div>
      </section>
    );
  }
}

export default withTranslation()(ProfileAgentPage);




// WEBPACK FOOTER //
// ./src/containers/ProfileAgent/index.js